import {lazy, Suspense, useEffect} from 'react';
import {useAtom} from 'jotai';
import {
  countrySelectModalAtom,
  countriesWithoutShippingModalAtom,
  getShippingUpdatesFormDialogAtom,
  countryWeShipToDialogAtom,
  countryManagedByDistributorDialogAtom,
  countryWithoutShippingDialogAtom,
} from '../../jotai';
import useGeo from '../../hooks/useGeo';
import {
  COUNTRIES_WE_SHIP_TO,
  COUNTRY_CODES_MANAGED_BY_DISTRIBUTOR,
} from '../../constants';

const CountrySelect = lazy(() => import('../modals/CountrySelect.client'));
const CountriesWithoutShipping = lazy(
  () => import('../modals/CountriesWithoutShipping.client'),
);
const GetShippingUpdatesForm = lazy(
  () => import('../modals/GetShippingUpdatesForm.client'),
);
const CountryWeShipTo = lazy(() => import('../modals/CountryWeShipTo.client'));
const CountryManagedByDistributor = lazy(
  () => import('../modals/CountryManagedByDistributor.client'),
);
const CountryWithoutShipping = lazy(
  () => import('../modals/CountryWithoutShipping.client'),
);

export default function Modals() {
  const [showCountrySelect, setShowCountrySelect] = useAtom(
    countrySelectModalAtom,
  );
  const [showCountriesWithoutShipping, setShowCountriesWithoutShipping] =
    useAtom(countriesWithoutShippingModalAtom);
  const [showGetShippingUpdatesForm, setShowGetShippingUpdatesForm] = useAtom(
    getShippingUpdatesFormDialogAtom,
  );
  const [showCountryWeShipTo, setShowCountryWeShipTo] = useAtom(
    countryWeShipToDialogAtom,
  );
  const [showCountryManagedByDistributor, setShowCountryManagedByDistributor] =
    useAtom(countryManagedByDistributorDialogAtom);
  const [showCountryWithoutShipping, setShowCountryWithoutShipping] = useAtom(
    countryWithoutShippingDialogAtom,
  );

  const {
    xVercelIpCountryCookie,
    preferredCountryCookie,
    acceptedWrongCountryCookie,
    currentCountryPath,
    onCorrectPath,
  } = useGeo();

  useEffect(() => {
    const showModal =
      (!onCorrectPath &&
        preferredCountryCookie !== xVercelIpCountryCookie &&
        !acceptedWrongCountryCookie) ||
      (!acceptedWrongCountryCookie && !onCorrectPath);

    // Handle countries we ship to
    if (
      showModal &&
      COUNTRIES_WE_SHIP_TO.includes(xVercelIpCountryCookie.toUpperCase())
    ) {
      setShowCountryWeShipTo(true);

      // Handle countries managed by distributor
    } else if (
      COUNTRY_CODES_MANAGED_BY_DISTRIBUTOR.includes(
        xVercelIpCountryCookie.toUpperCase(),
      ) &&
      !acceptedWrongCountryCookie
    ) {
      setShowCountryManagedByDistributor(true);
      // Handle countries we don't ship to
    } else if (
      !onCorrectPath &&
      xVercelIpCountryCookie !== currentCountryPath &&
      !acceptedWrongCountryCookie
    ) {
      setShowCountryWithoutShipping(true);
    }
  }, []);

  return (
    <>
      {showCountrySelect && (
        <Suspense>
          <CountrySelect onClose={() => setShowCountrySelect(false)} />
        </Suspense>
      )}

      {showCountriesWithoutShipping && (
        <Suspense>
          <CountriesWithoutShipping
            onClose={() => setShowCountriesWithoutShipping(false)}
          />
        </Suspense>
      )}

      {showGetShippingUpdatesForm && (
        <Suspense>
          <GetShippingUpdatesForm
            onClose={() => setShowGetShippingUpdatesForm(false)}
          />
        </Suspense>
      )}

      {showCountryWeShipTo && (
        <Suspense>
          <CountryWeShipTo onClose={() => setShowCountryWeShipTo(false)} />
        </Suspense>
      )}

      {showCountryManagedByDistributor && (
        <Suspense>
          <CountryManagedByDistributor
            onClose={() => setShowCountryManagedByDistributor(false)}
          />
        </Suspense>
      )}

      {showCountryWithoutShipping && (
        <Suspense>
          <CountryWithoutShipping
            onClose={() => setShowCountryWithoutShipping(false)}
          />
        </Suspense>
      )}
    </>
  );
}
